import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e6d64bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_3 = { class: "dialog-footer" }

import { onMounted, PropType, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ValidationFilter, ValidationResult } from "@/types/estimation.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { Parameter } from "@/types/parameter.type";
import { getResult_2, getPaginatedEstimations } from "@/service/estimation.service";
import ValidationResultDialogComponent from "../information/ValidationResultDialog.component.vue";
import { DataUpload } from "@/types/dataupload.type";


export default /*#__PURE__*/_defineComponent({
  props: {
  samplingPoint: {
    type: Object as PropType<SamplingPoint>,
    rquired: true,
    immediate: true,
    deep: true,
  },
  parameter: {
    type: Object as PropType<Parameter>,
    required: true,
    immediate: true,
    deep: true,
  },
  dataUpload: {
    type: Object as () => DataUpload[],
    required: true,
    immediate: true,
    deep: true,
  },

  startDate: { type: Date, required: false, immediate: true, deep: true },
  endDate: { type: Date, required: false, immediate: true, deep: true },
},
  setup(__props) {

const props = __props

const { t } = useI18n();
const dialogVisible = ref(false);

// - props


watch(
  () => props.dataUpload,
  () => {
    calculateResult();
  }
);

const validationResult = reactive<ValidationResult>({
  mae: 0,
  sur: 0,
  mape: 0,
});

onMounted(async () => {
  await calculateResult();
});

const calculateResult = async () => {
  if (props.dataUpload) {
    const validationFilter = {
      samplingPointId: [props.samplingPoint?.id],
      parameterId: [props.parameter.id],
      date: [props.startDate, props.endDate],
    } as ValidationFilter;

    const estimations = await getPaginatedEstimations(validationFilter);

    const result = await getResult_2(validationFilter, props.dataUpload, estimations);

    validationResult.mae = result.mae;
    validationResult.sur = result.sur;
    validationResult.mape = result.mape;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$t("subtitle.validationResult")) + " ", 1),
      _createVNode(_component_el_button, {
        class: "info",
        size: "small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = true)),
        circle: ""
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_descriptions, {
      direction: "vertical",
      column: 2,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, { label: "MAE" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(validationResult).mae ? _unref(validationResult).mae.toFixed(2) : _unref(validationResult).mae), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "MAE porcentual" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(validationResult).mape ? _unref(validationResult).mape.toFixed(2) : _unref(validationResult).mape), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "SuR 20%" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(validationResult).sur ? _unref(validationResult).sur.toFixed(2) : _unref(validationResult).sur), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      title: _unref(t)('label.description'),
      "custom-class": "app-form"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("btn.close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(ValidationResultDialogComponent)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})